import script from "./V4AllAvailableContent.vue?vue&type=script&setup=true&lang=js"
export * from "./V4AllAvailableContent.vue?vue&type=script&setup=true&lang=js"

import "./V4AllAvailableContent.vue?vue&type=style&index=0&id=ba515b54&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba515b54"]])

export default __exports__